/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, effect, ElementRef, input, InputSignal, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Chart, LineController, LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend, ChartConfiguration, ChartOptions, Filler } from 'chart.js';
Chart.register(LineController, LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend, Filler);

@Component({
    selector: "app-details-gpx-elevation",
    imports: [
        CommonModule,
        TranslateModule,
    ],  
    standalone: true,
    templateUrl: "./elevation.component.html",
    styleUrls: ["./elevation.component.scss"],
})

export class ElevationComponent {
    public elevationData: InputSignal<any> = input<any>();
    //public gpxStatsData: InputSignal<any> = input<any>();
    public totalDistance: InputSignal<number> = input<number>(); 
    
    @ViewChild('elevationCanvas') elevationCanvas!: ElementRef<HTMLCanvasElement>;
    private elevationChart?: Chart<'line'>;
    public lineChartOptions: ChartOptions<'line'> = {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: { 
                enabled: false 
            }
        },
        scales: {
            x: {
                type: 'linear',
                display: false,
                title: {
                    display: false,
                },
                grid: {
                    display: false,
                },
                ticks: {
                    display: false,
                }
            },
            y: {
                display: false,
                title: {
                    display: false,
                },
                grid: {
                    display: false,
                },
                ticks: {
                    display: false,
                }
            },
        }
    };

    gpxElevationEffect = effect(() => {
        const gpxElevation = this.elevationData();
        //const gpxStats = this.gpxStatsData();
        if (!gpxElevation)
            return;

        this.updateElevationChart(gpxElevation);
    })

    private updateElevationChart(gpxElevation): void {
        if (!this.elevationCanvas) 
            return;

        const ctx = this.elevationCanvas.nativeElement.getContext('2d');
        if (!ctx) 
            return;

        const labels = gpxElevation.map(p => p.distance.toFixed(2));
        const gradient = ctx.createLinearGradient(0, 0, 0, this.elevationCanvas.nativeElement.height);
        gradient.addColorStop(0, "rgba(255, 165, 0, 0.4)");
        gradient.addColorStop(0.3, "rgba(180, 200, 120, 0.5)");
        gradient.addColorStop(1, "rgba(120, 160, 80, 0.9)");

        const data = gpxElevation.map(p => ({ 
            x: p.distance,
            y: p.elevation
        }));

        const maxDistance = data[data.length - 1].x;
        const options: ChartOptions<'line'> = {
            ...this.lineChartOptions,
            scales: {
                ...this.lineChartOptions.scales,
                x: {
                    ...(this.lineChartOptions.scales?.x as any),
                    min: 0,
                    max: maxDistance,
                },
            }
        };
        const chartData: ChartConfiguration<'line'>['data'] = {
            labels,
            datasets: [
                {
                    label: 'Elevación (m)',
                    data,
                    borderWidth: 3,
                    borderColor: '#e08b00',
                    backgroundColor: gradient,
                    fill: true,
                    pointRadius: 0,
                    tension: 0.25,
                },
            ]
        };

        if (this.elevationChart) {
            this.elevationChart.data = chartData;
            this.elevationChart.update();
        } else {
            this.elevationChart = new Chart(ctx, {
                type: 'line',
                data: chartData,
                options: options
            });
        }
    }

    ngOnDestroy(): void {
        if (this.elevationChart) 
            this.elevationChart.destroy();
    }
}